import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { DATE_FILTER_CHANGE, SCANBACK_CHANGE } from '../constants'

import { GET_DEEPFAKE_ANALYTIC_ASYNC } from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {
      analytics: [],
    },
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATE_FILTER_CHANGE:
      case SCANBACK_CHANGE:
      case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
      case GET_DEEPFAKE_ANALYTIC_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case GET_DEEPFAKE_ANALYTIC_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: action.payload.data,
        }
      case GET_DEEPFAKE_ANALYTIC_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
        }
      case GET_DEEPFAKE_ANALYTIC_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
        }
      default:
        return state
    }
  }
}
